import styled from 'styled-components';

export const BlogHeaderStyle = styled.div`
  background: ${({ theme }) => theme.colors[3]};
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 0px 8px 0px;
  transition: top 0.7s;
  .header {
    max-width: 1024px;
    margin: 0 auto;
    height: 55px;
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme.colors[3]};
    width: 100%;
    justify-content: space-between;
  }
  .header-brand {
    display: flex;
    align-items: center;
    cursor: pointer;
    svg {
      width: 35px;
      height: 35px;
    }
  }
  .logo-title {
    color: #1976d2;
    font-size: 20px;
    text-align: start;
    margin: 0 8px 0 8px;
  }
  @media only screen and (max-width: 400px) {
    .company-brand {
      margin-top: 18px;
    }
    .logo-title {
      display: none;
    }
  }
  .option-header {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    margin-top: 6px;
    margin-right: 8px;
  }
  .icon-style {
    fill: ${({ theme }) => theme.svg1};
    width: 22px;
    height: 22px;
    &:hover {
      cursor: pointer;
      fill: #1976d2;
    }
  }
`;

export const BlogContainer = styled.div`
  max-width: 1024px;
  padding: 0 8px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 35px;
  padding-bottom: 50px;
  .benefits-list {
    list-style: none;
    padding: 0;
    margin-top: 1rem;
  }
  // @media only screen and (max-width: 600px) {
  //   margin-top: 16px;
  // }
  .benefits-list li {
    margin-bottom: 1rem;
    padding-left: 1.5rem;
    position: relative;
    font-size: 1rem;
    line-height: 1.6;
  }

  .benefits-list li::before {
    content: '✅';
    position: absolute;
    left: 0;
    top: 0;
  }
`;

export const BlogArrowBack = styled.div`
  padding-top: 12px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 55px;
  height: 35px;
  border-radius: 2px;
  z-index: 1;
  background-color: ${({ theme }) => theme.Bg1};
  transition: top 0.7s;
  > div:first-child {
    margin: 0 8px;
  }
`;

export const BlogListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  padding: 2rem 0;
  margin-top: 55px;
  @media screen and (max-width: 600px) {
    margin-top: 2.4rem;
    gap: 1rem;
  }
`;

export const BlogCard = styled.div`
  background: ${({ theme }) => theme.Bg1};
  padding: 1rem 1rem 1.5rem;
  border-radius: 10px;
  box-shadow: ${({ theme }) => theme.boxShadow1};
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h2 {
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }

  p {
    font-size: 0.95rem;
    color: #666;
    margin-bottom: 1rem;
  }

  .read-more-btn {
    align-self: flex-start;
    background: #2b99f5;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 5px;
    text-decoration: none;
    font-weight: bold;
  }

  .read-more-btn:hover {
    opacity: 0.9;
  }
`;
export const ProfilePopoverContent = styled.div`
  font-size: 15px;
  color: ${({ theme }) => theme.text1};
  width: 180px;

  .language-item {
    padding: 12px 18px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    color: ${({ theme }) => theme.text1};
    display: flex;
    align-items: center;

    &:hover {
      background-color: ${({ theme }) => theme.hoverBg1};
    }
  }
  .language-active-item {
    color: #1976d2;
    font-weight: 500;
    background-color: ${({ theme }) => theme.hoverBg1};
  }
`;
